import { autoinject, transient } from "aurelia-dependency-injection";
import { BaseRuleParameters } from "../modules/customers/steps/rule-parameters/base-rule-parameters";
import { LookupClientService } from "../../../services/lookups/lookup-client.service";
import {
    RightshipRuleConfigParameterModel
} from "../../../models/customers/customer.models";
import { ManageRightShipUsersClientService } from "../../../services/modules/righship-qi-manage-users.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { BindingEngine } from "aurelia-binding";
import { I18N } from "aurelia-i18n";
import { useView } from "aurelia-framework";

@autoinject
@transient()
@useView('views/pages/settings/rightship-rule-parameters.html')
export class RightshipRuleParameters extends BaseRuleParameters<RightshipRuleConfigParameterModel> {
    constructor(lookupValueService: LookupClientService, eventAggregator: EventAggregator, 
        private manageRightShipUsersClientService: ManageRightShipUsersClientService, dialogClientServices: DialogClientService,
        i18n:I18N, bindingEngine: BindingEngine) {
        super(lookupValueService, eventAggregator, dialogClientServices, i18n, bindingEngine);
    }

    async activate(args: any) {
        const rsRuleConfigParameters = await this.manageRightShipUsersClientService.getRsRuleConfigParameters();
        await super.activate(args, rsRuleConfigParameters, "rightshipRuleConfigParameterId");
    }
    
    getODataUrl(): string {
        return "RightshipRuleConfigParameters";
    }
}